import { Component, OnInit } from "@angular/core";
import { Contact } from "../../models/api/contact";
import { ApiService } from "../../services/api.service";
import { HttpErrorResponse } from "@angular/common/http";
import Swal from "sweetalert2";
import { Contacts } from "../../models/contact.model";
import { HttpClient } from "@angular/common/http";
import { Product } from "src/app/models/product";
import { ProductService } from "src/app/services/product.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  contact: Contact = new Contact();
  isLoading = false;
  buttonMsg = "Subscribe";

  toastProduct: Product;
  toastMessage: string;
  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private productService: ProductService
  ) {}

  ngOnInit() {}

  onNavigate() {
    window.open("https://api.whatsapp.com/send?phone=13373997000", "_blank");
    let contact = new Contacts();
    this.http.get<{ ip: string }>("https://jsonip.com").subscribe((data) => {
      console.log("the data", data.ip);
      this.http
        .get<{
          ip: string;
          country: string;
          city: string;
          org: string;
        }>("https://ipinfo.io/" + data.ip + "?token=2824b78dc815fe")
        .subscribe((geo) => {
          console.log("the geo data", geo);
          contact.name = "New WhatsApp Click Data";
          contact.email = "None";
          contact.phone = "None";
          contact.subject = "WhatsApp button click tracking data";
          contact.message =
            "IP address: " +
            geo.ip +
            ", Country: " +
            geo.country +
            ", City: " +
            geo.city +
            ", Organization: " +
            geo.org;
          this.apiService
            .contacts(contact)
            .subscribe((lol) => console.log(lol));
        });
    });
  }

  submit() {
    this.buttonMsg = "Loading...";
    this.contact.subject = "Email Subscription";
    this.apiService.contact(this.contact).subscribe(
      (data: any) => {
        this.isLoading = true;
        Swal({
          title: "Thanks!",
          text: "Thank you! Your message has been subscribe.",
          type: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#07a763",
        });
        this.contact = new Contact();
        this.isLoading = false;
        this.buttonMsg = "Subscribe";
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        Swal({
          title: "Error!",
          text: "Unable to Subscribe email. Make sure you are connected to the internet",
          type: "warning",
          confirmButtonText: "Ok got it!",
          confirmButtonColor: "#07a763",
        });
        this.buttonMsg = "Subscribe";
      }
    );
  }
}
